import curd from '../curd'
const BASE_PATH = '/rule/factor/config'

export default curd(BASE_PATH, {
  getFactorOptions: () => ({
    url: `${BASE_PATH}/factorList`,
    method: 'GET'
  }),
  factorRuleSave: (data) => ({
    url: BASE_PATH,
    method: 'POST',
    data
  }),
  factorRuleUpdate: data => ({
    url: BASE_PATH,
    method: 'PUT',
    data
  }),
  pageList: (params) => ({
    url: `${BASE_PATH}/pageList`,
    method: 'GET',
    params: params
  }),
  updFactorStatus: (params) => ({
    url: `${BASE_PATH}/updStatus`,
    method: 'POST',
    params: params
  }),
  delFactorConfig: (params) => ({
    url: BASE_PATH,
    method: 'DELETE',
    params: params
  }),
  getFactorConfigList: () => ({
    url: `${BASE_PATH}/getList`,
    method: 'GET',
    params: {}
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/FactorRuleConfig.js